module.exports = __webpack_public_path__ + "static/battle_03-68bbfcedb8500d2dfc70e2bf5f42f489.jpg";